.container {
  position: relative;
  margin: 1rem 0;
}

.label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0 0 0.5rem;
}

.grid {
  display: grid;
  /* At most four columns where there is room, fewer in a narrow column or on mobile. */
  grid-template-columns: repeat(auto-fill, minmax(max(8.5rem, calc((100% - 3rem) / 4)), 1fr));
  gap: 1rem;
  justify-items: center;
  text-align: center;
}

.item {
  width: 100%;
  cursor: pointer;
  padding: 1rem;
  overflow-wrap: anywhere;
  border: none;
  border-radius: 0.5rem;
  background: transparent;
  outline: 1px solid #bbb;
  font: inherit;
  font-size: 2rem;
  transition:
    outline-color 0.2s ease,
    outline-width 0.2s ease;
}

.item:hover {
  outline-color: var(--color-text);
}

.selected {
  outline-width: 3px;
  outline-color: var(--color-text);
}

@media (max-width: 599px) {
  .item {
    padding: 0.75rem;
  }
}
